export default __webpack_public_path__ + "assets/rss.9ce407c3.svg";